export default __webpack_public_path__ + "static/media/user-folder.a2ebbe3f.svg";